import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacabservice() {



  const cardData =
  {
    keyword: 'Pune to Lonavala Cab Service',
    heading: 'Sanavi Travels: Pune to Lonavala Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Lonavala Cab Service, providing safe, comfortable, and hassle-free transportation for families, friends, corporate groups, and tourists planning a scenic getaway from Pune to Lonavala. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxing journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Lonavala attractions such as Lion’s Point, Bhushi Dam, Rajmachi Fort, Karla Caves, Bhaja Caves, and Tungarli Lake. Choose Sanavi Travels for trusted Pune to Lonavala cab services, delivering comfort, safety, and a memorable hill-station travel experience.',

    top: 'Top Places to Visit in Lonavala with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a popular monsoon destination in Lonavala, surrounded by lush greenery and flowing waters. Visitors enjoy picnics, water play, and photography. The dam area becomes especially lively during the rainy season, offering a refreshing retreat from city life."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap, also called Tiger’s Point, is a dramatic cliff-top viewpoint offering panoramic views of the Western Ghats and valleys. Its unique rock formation resembling a leaping tiger attracts trekkers, photographers, and nature enthusiasts, especially during sunrise and sunset."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a serene waterbody surrounded by hills and greenery, ideal for peaceful walks, picnics, and birdwatching. It is particularly scenic during and after the monsoon season, offering calm and natural beauty in the heart of Lonavala."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic hill fort near Lonavala, famous for trekking and its strategic significance during the Maratha era. Trekkers enjoy panoramic views of the Sahyadri ranges and lush valleys along the trail. The fort is an adventure and history hotspot."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves near Lonavala, dating back to 2nd century BCE. Featuring intricately carved chaityas (prayer halls) and stupas, the caves showcase early Indian architecture and spiritual heritage, attracting history enthusiasts and pilgrims alike."
  },
  {
    "title": "Kune Waterfalls",
    "description": "Kune Waterfalls is a spectacular three-tiered waterfall near Lonavala, surrounded by dense forests and hills. Especially stunning during the monsoon, it is a favorite for nature lovers, photographers, and picnickers seeking scenic tranquility."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is a popular viewpoint offering sweeping vistas of the valleys, mountains, and sunsets. It is a favorite for early morning and evening visits, providing a peaceful and picturesque spot for tourists and photographers."
  },
  {
    "title": "Duke’s Nose",
    "description": "Duke’s Nose is a cliff with a unique shape resembling a nose, ideal for trekking and adventure enthusiasts. The viewpoint offers panoramic views of the surrounding valleys, hills, and waterfalls, making it one of Lonavala’s thrilling attractions."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is a historic fort near Lonavala, known for its large gates, ramparts, and trekking trails. The fort provides stunning views of the Western Ghats and monsoon-fed landscapes, making it a perfect blend of history and adventure."
  },
  {
    "title": "Dhamini Waterfalls",
    "description": "Dhamini Waterfalls, a hidden gem near Lonavala, is surrounded by lush greenery and rocky terrain. It is ideal for trekking, picnics, and photography, especially during the monsoon season, offering a peaceful natural retreat."
  }
]
,




"services": [
  {
    "name": "Pune to Lonavala Cab Service",
    "description": "Pune to Lonavala Cab Service provides comfortable and reliable cab travel from Pune to Lonavala. Ideal for weekend trips, sightseeing, and leisure travel with professional drivers."
  },
  {
    "name": "Lonavala Cab from Pune",
    "description": "Lonavala Cab from Pune offers convenient door-to-door cab services for individuals, families, and groups traveling to the popular hill station of Lonavala."
  },
  {
    "name": "AC Cab Pune to Lonavala",
    "description": "AC Cab Pune to Lonavala ensures a cool and comfortable journey, especially suited for long-distance travel in air-conditioned vehicles with experienced chauffeurs."
  },
  {
    "name": "Luxury Cab Lonavala Trip",
    "description": "Luxury Cab Lonavala Trip provides premium cabs with added comfort and amenities, perfect for travelers seeking a high-end, relaxed experience to Lonavala."
  },
  {
    "name": "Family Cab Lonavala",
    "description": "Family Cab Lonavala caters to families with spacious seating, safety features, and luggage space, making the trip enjoyable for all family members."
  },
  {
    "name": "Outstation Cab Lonavala",
    "description": "Outstation Cab Lonavala offers dedicated cab services for trips beyond Pune, ensuring comfortable travel with professional drivers and flexible schedules."
  },
  {
    "name": "Affordable Cab Lonavala",
    "description": "Affordable Cab Lonavala provides budget-friendly travel options without compromising comfort, ideal for cost-conscious travelers and small groups."
  },
  {
    "name": "Chauffeur Driven Cab Lonavala",
    "description": "Chauffeur Driven Cab Lonavala ensures safe and hassle-free travel with professional drivers who manage routes, traffic, and navigation for a relaxed journey."
  },
  {
    "name": "Best Cab Pune to Lonavala",
    "description": "Best Cab Pune to Lonavala guarantees high-quality vehicles, punctual service, and a smooth travel experience, making it one of the most reliable options for this route."
  },
  {
    "name": "Pune Lonavala Taxi",
    "description": "Pune Lonavala Taxi provides convenient and reliable taxi services for individuals or groups traveling from Pune to Lonavala for leisure or business purposes."
  },
  {
    "name": "Tourist Cab Lonavala",
    "description": "Tourist Cab Lonavala caters to travelers exploring the hill station, offering guided routes, comfortable vehicles, and flexible timings for sightseeing and leisure activities."
  },
  {
    "name": "Hill Station Cab Pune",
    "description": "Hill Station Cab Pune specializes in trips to nearby hill stations like Lonavala, ensuring safe and scenic travel experiences with professional drivers."
  },
  {
    "name": "Weekend Trip Cab Lonavala",
    "description": "Weekend Trip Cab Lonavala is perfect for short getaways, providing well-maintained cabs for a relaxing weekend trip from Pune to the hills."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to conveniently book cabs for Lonavala and other destinations in Pune with instant confirmation and flexible options."
  },
  {
    "name": "Lonavala Travel Cab",
    "description": "Lonavala Travel Cab offers dedicated transportation services for Lonavala trips, ensuring comfort, safety, and reliability for all travelers."
  }
],
"tableData": [
  ["Pune to Lonavala Cab Service", "Lonavala Cab from Pune"],
  ["AC Cab Pune to Lonavala", "Luxury Cab Lonavala Trip"],
  ["Family Cab Lonavala", "Outstation Cab Lonavala"],
  ["Affordable Cab Lonavala", "Chauffeur Driven Cab Lonavala"],
  ["Best Cab Pune to Lonavala", "Pune Lonavala Taxi"],
  ["Tourist Cab Lonavala", "Hill Station Cab Pune"],
  ["Weekend Trip Cab Lonavala", "Online Cab Booking Pune"],
  ["Lonavala Travel Cab", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Lonavala Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services from Pune to Lonavala, perfect for weekend trips, family outings, corporate travel, and hill station excursions."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, spacious, and regularly serviced cabs designed for a smooth and relaxing journey from Pune to Lonavala."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Lonavala Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Lonavala highway and ghat sections, ensuring safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Lonavala cab services, including fuel, tolls, and driver allowances—no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel‑related queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized cab packages to suit your Pune to Lonavala travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Lonavala cab services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Pune to Lonavala?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable cab services from Pune to Lonavala.'
  },
  {
    question: 'How can I book a cab from Pune to Lonavala?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Lonavala trips?',
    answer: 'We provide a variety of cabs including sedans, SUVs, and premium cars to suit your travel preferences.'
  },
  {
    question: 'Are drivers experienced with the Pune–Lonavala route?',
    answer: 'Yes, our drivers are professional, licensed, and knowledgeable about the Pune to Lonavala route for safe travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred locations for both pickup and drop‑off.'
  },
  {
    question: 'Is the cab service available 24x7?',
    answer: 'Yes, our cab service from Pune to Lonavala is available round the clock for your convenience.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All vehicles are cleaned and sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate account payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Lonavala trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit More',
    feedback: 'Booked a cab from Pune to Lonavala with Sanavi Travels. Comfortable ride, smooth service, and timely pickup! Highly recommend.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent cab service! The driver was professional, and our journey to Lonavala was pleasant and hassle‑free.',
    rating: 5
  }
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cab Service - Sanavi Travels",
  "description": "Book Pune to Lonavala cab service with Sanavi Travels. AC and luxury cabs for family trips, weekend getaways, hill station tours, outstation travel, and comfortable chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Lonavala Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Lonavala with Sanavi Travels. Perfect for family trips, weekend getaways, hill station tours, outstation travel, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalacabservice;